module.exports = __webpack_public_path__ + "media/components/Application/Influencers/Index/afloat-6261f47e0e9ac7fbcb01ce8de6461a90.png";